import React, { useState, useEffect, useCallback, useRef } from "react";
import Modal from "react-modal";
import { DatePicker } from "antd";
import dayjs from "dayjs";

import { getStudentsData } from "../components/Studentsdata";
import { AiOutlineClose } from "react-icons/ai";
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import { IoIosCloseCircle } from "react-icons/io";
import useSelectedUniversity from "../hooks/useSelectedUniversity";
import { getSessionUniversityId } from "../utils/sessionUser";
import SummaryApi from "../common";
import { toast } from "react-toastify";
import { IoCall } from "react-icons/io5";
import { Link } from "react-router-dom";

Modal.setAppElement("#root");

const SHOW_TIME_CONFIG = {
  format: "hh:mm A",
  use12Hours: true,
  defaultValue: dayjs("09:00 AM", "hh:mm A"),
};

// ================= THEME (UI rules) =================
const THEME = {
  primary: "rgb(23, 44, 87)", // #172C57 — main brand color
  primaryLight: "rgba(23, 44, 87, 0.08)",
  actionBlue: "#2563EB", // normal blue (table action buttons)
  actionBlueHover: "#1D4ED8",
  actionYellow: "#D97706", // amber (View More)
  actionYellowHover: "#B45309",
  actionGreen: "#10B981", // success / download / positive
  actionGreenHover: "#059669",
  actionPurple: "#7C3AED", // special action
  actionPurpleHover: "#6D28D9",
  actionRed: "#EF4444", // danger / clear / deactivate
  actionRedHover: "#DC2626",
  disabledGray: "#D1D5DB",
};

// Sticky action columns (right side of the table)
const STICKY_ACCESSORS = ["edit"];

// Sticky cells must match the row color (base + hover) so scrolled content never shows through
const STICKY_HOVER_MAP = {
  "hover:bg-green-200": "group-hover/row:bg-green-200",
  "hover:bg-yellow-100": "group-hover/row:bg-yellow-100",
  "hover:bg-gray-50": "group-hover/row:bg-gray-50",
  "hover:bg-red-100": "group-hover/row:bg-red-100",
};
const getStickyCellBg = (rowColor, hoverColor) =>
  `${rowColor} ${STICKY_HOVER_MAP[hoverColor] || ""}`;

const AssignedStudents = () => {
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [modalVisible, setModalVisible] = useState(false);
  const [currentStudent, setCurrentStudent] = useState(null);
  const [followUpDateTime, setFollowUpDateTime] = useState(null);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [studentsData, setStudentsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [todayTaskfollowedUpCount, setTodayTaskFollowedUpCount] = useState(0);
  const [previousTaskfollowedUpCount, setPreviousTaskFollowedUpCount] = useState(0);
  const [taskTodayNotFollowedUpCount, setTaskTodayNotFollowedUpCount] = useState(0);
  const [taskPreviousNotFollowedUpCount, setTaskPreviousNotFollowedUpCount] = useState(0);
  const [selectedCourses, setSelectedCourses] = useState([]);
  const [dropdownValue, setDropdownValue] = useState("");
  const [timer, setTimer] = useState("00:00:00");
  const [intervalId, setIntervalId] = useState(null);
  const [inTime, setInTime] = useState("");
  const [outTime, setOutTime] = useState("");
  const [initialStatus, setInitialStatus] = useState("");
  const universityId = useSelectedUniversity();
  const requestId = useRef(0);
  const [checklistItems, setChecklistItems] = useState([]);
  const [selectedChecklist, setSelectedChecklist] = useState([]);
  const [checklistDropdown, setChecklistDropdown] = useState("");

  const indianStates = [
    "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh",
    "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand", "Karnataka",
    "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur", "Meghalaya", "Mizoram",
    "Nagaland", "Odisha", "Punjab", "Rajasthan", "Sikkim", "Tamil Nadu",
    "Telangana", "Tripura", "Uttar Pradesh", "Uttarakhand", "West Bengal",
    "Andaman and Nicobar Islands", "Chandigarh",
    "Dadra and Nagar Haveli and Daman and Diu", "Delhi", "Jammu and Kashmir",
    "Ladakh", "Lakshadweep", "Puducherry",
  ];

  const disabledDate = useCallback((current) => {
    return current && current.isBefore(dayjs().startOf("day"));
  }, []);

  const disabledTime = useCallback((current) => {
    if (!current || !current.isSame(dayjs(), "day")) return {};
    const now = dayjs();
    const currentHour = now.hour();

    return {
      disabledHours: () => Array.from({ length: currentHour }, (_, i) => i),
      disabledMinutes: (hour) =>
        hour === currentHour
          ? Array.from({ length: now.minute() }, (_, i) => i)
          : [],
    };
  }, []);

  useEffect(() => {
    const fetchChecklist = async () => {
      try {
        const res = await fetch(SummaryApi.GetAllChecklists.url, {
          method: SummaryApi.GetAllChecklists.method.toUpperCase(),
        });
        const result = await res.json();
        if (result.status) setChecklistItems(result.data || []);
        // else toast.error(result.message || "Failed to load checklist");
      } catch (err) {
        // toast.error("Unable to load checklist");
      }
    };
    fetchChecklist();
  }, []);

  const isValidDate = (d) => !!d && !String(d).startsWith("0000");
  const dayOf = (d) => String(d || "").slice(0, 10);
  const isEnrolled = (row) => Number(row.is_follow_up) === 1;

  const ugCourses = [
    "CSE",
    "CSE(AI & ML)",
    "CSE(AI & DS)",
    "AERONAUTICAL ENGINERRING",
    "ECE",
  ];
  const pgCourses = [];
  const districts = [
    "Alluri Sitharama Raju",
    "Anakapalli",
    "Ananthapuram",
    "Annamayya",
    "Bapatla",
    "CHITTOOR",
    "EAST GODAVARI",
    "Eluru",
    "Guntur",
    "Kakinada",
    "Konaseema",
    "Krishna",
    "Kurnool",
    "Manyam",
    "Nandyal",
    "NTR",
    "Palnadu",
    "Prakasam",
    "Srikakulam",
    "SPS Nellore",
    "Sri Satyasai",
    "Tirupathi",
    "Vizianagaram",
    "Visakhapatnam",
    "West Godavari",
    "YSR Kadapa",
  ];

  useEffect(() => {
    if (modalVisible) {
      let seconds = 0;
      const id = setInterval(() => {
        seconds++;
        const hours = String(Math.floor(seconds / 3600)).padStart(2, "0");
        const minutes = String(Math.floor((seconds % 3600) / 60)).padStart(2, "0");
        const secs = String(seconds % 60).padStart(2, "0");
        setTimer(`${hours}:${minutes}:${secs}`);
      }, 1000);
      setIntervalId(id);
    } else {
      clearInterval(intervalId);
      setTimer("00:00:00");
    }
    return () => clearInterval(intervalId);
  }, [modalVisible]);

  const getFormattedISTTime = () => {
    const now = new Date();
    const istOffset = 5.5 * 60 * 60 * 1000;
    const istTime = new Date(now.getTime() + istOffset);

    const year = istTime.getUTCFullYear();
    const month = String(istTime.getUTCMonth() + 1).padStart(2, "0");
    const day = String(istTime.getUTCDate()).padStart(2, "0");
    const hours = String(istTime.getUTCHours()).padStart(2, "0");
    const minutes = String(istTime.getUTCMinutes()).padStart(2, "0");
    const seconds = String(istTime.getUTCSeconds()).padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };

  const getCurrentDate = () => {
    const today = new Date();
    const day = today.getDate().toString().padStart(2, "0");
    const month = (today.getMonth() + 1).toString().padStart(2, "0");
    const year = today.getFullYear();
    return `${year}-${month}-${day}`;
  };

  const fetchData = async () => {
    const myRequest = ++requestId.current;
    try {
      setLoading(true);
      const data = await getStudentsData();
      if (myRequest !== requestId.current) return;
      setStudentsData(data);

      const today = getCurrentDate();
      let todayTaskFollowedUp = 0;
      let previousTaskFollowedUp = 0;
      let todayNotFollowedUp = 0;
      let previousNotFollowedUp = 0;

      data.forEach((student) => {
        const created = dayOf(student.created_date);
        const followed = isEnrolled(student);

        if (created === today) {
          followed ? todayTaskFollowedUp++ : todayNotFollowedUp++;
        } else if (created < today) {
          followed ? previousTaskFollowedUp++ : previousNotFollowedUp++;
        }
      });

      setTodayTaskFollowedUpCount(todayTaskFollowedUp);
      setPreviousTaskFollowedUpCount(previousTaskFollowedUp);
      setTaskTodayNotFollowedUpCount(todayNotFollowedUp);
      setTaskPreviousNotFollowedUpCount(previousNotFollowedUp);
    } catch (err) {
      console.error("Error fetching student data:", err);
      setError("Failed to fetch student data");
    } finally {
      if (myRequest === requestId.current) setLoading(false);
    }
  };

  useEffect(() => {
    setPageIndex(0);
    fetchData();
  }, []);

  const memberType = atob(sessionStorage.getItem("K3M8X1JQ5VZ4B7PWTL9") || "");

  const [formData, setFormData] = useState({
    student_name: "",
    employee_student_id: "",
    employee_id: "",
    gender: "Male",
    father_name: "",
    mobile_number1: "",
    mobile_number2: "",
    email: "",
    aadhar_number: "",
    state: "",
    district: "",
    city: "",
    address: "",
    code: "",
    pincode: "",
    clg_name: "",
    course: "",
    ug_pg_course: "",
    year: "",
    mobile_number: "",
    is_follow_up: false,
    program_type: "Full-time",
    is_interested: "",
    call_back_reason: "",
    is_digital_lead: "0",
    lead_type: "",
    other_reasons: "",
    call_status: "",
    call_duration: "00:00:00.000000",
    remarks: "",
    is_active: false,
    created_date: "",
    follow_up_date: "",
    native_district: "",
    native_address: "",
    other_universities: "",
    other_state: "",
  });

  const validateForm = () => {
    const { call_status, is_interested, call_back_reason, other_reasons } = formData;

    if (call_status === "Contacted") {
      if (
        ![
          "Not Interested",
          "Interested",
          "Most Interested",
          "Call Back",
          "Others",
        ].includes(is_interested)
      ) {
        toast.warning(
          "Please select an option: Not Interested, Interested, Most Interested, Call Back, or Others."
        );
        return false;
      }

      if (is_interested === "Call Back" && !call_back_reason) {
        toast.warning("Please select a Call Back reason.");
        return false;
      }

      if (is_interested === "Others" && !other_reasons) {
        toast.warning("Please select an Other reason.");
        return false;
      }
    }

    return true;
  };

  const currentDistrict = (formData.district || "").trim();
  const districtOptions =
    !currentDistrict || districts.includes(currentDistrict)
      ? districts
      : [currentDistrict, ...districts];

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    if (isNaN(date)) return "NA";
    const options = { day: "2-digit", month: "short", year: "numeric" };
    return date.toLocaleDateString("en-GB", options);
  };

  useEffect(() => {
    if (modalVisible) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [modalVisible]);

  useEffect(() => {
    if (formData.call_duration) {
      const [timePart] = formData.call_duration.split(".");
      const [hours, minutes, seconds] = timePart
        .split(":")
        .map((part) => part.padStart(2, "0"));

      setFormData((prevData) => ({
        ...prevData,
        hours,
        minutes,
        seconds,
      }));
    }
  }, [formData.call_duration]);

  const columns = React.useMemo(
    () => [
      { Header: "SNO", accessor: "sno" },
      { Header: "District", accessor: "district" },
      { Header: "Student Name", accessor: "student_name" },
      { Header: "College Name", accessor: "clg_name" },
      { Header: "Course", accessor: "course" },
      { Header: "Mobile Number", accessor: "mobile_number" },
      {
        Header: "Task Date",
        accessor: "task_date",
      },
      {
        Header: "Enrolled Date",
        accessor: "follow_date",
        Cell: ({ row }) => {
          const { follow_up_date, is_follow_up } = row.original;
          if (is_follow_up === "0") {
            return <span>Not followed up yet</span>;
          }
          return <span>{formatDate(follow_up_date)}</span>;
        },
      },
      {
        Header: "Actions",
        accessor: "edit",
        Cell: ({ row }) => (
          <button
            onClick={() => handleOpenModal(row.original)}
            style={{ backgroundColor: THEME.actionBlue }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.backgroundColor = THEME.actionBlueHover)
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.backgroundColor = THEME.actionBlue)
            }
            className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-lg px-3 py-1.5 text-sm font-semibold text-white shadow-sm transition"
          >
            Enroll
          </button>
        ),
      },
    ],
    []
  );

  const updatedStudentsData = studentsData.map((student, index) => ({
    ...student,
    sno: index + 1,
  }));

  const pageCount = Math.ceil(studentsData.length / pageSize);
  const displayStart = pageIndex * pageSize + 1;
  const displayEnd = Math.min((pageIndex + 1) * pageSize, studentsData.length);
  const currentData = updatedStudentsData.slice(
    pageIndex * pageSize,
    (pageIndex + 1) * pageSize
  );

  const handleOpenModal = (student = null) => {
    const currentDateTime = getFormattedISTTime();
    setInTime(currentDateTime);

    if (student) {
      const callDuration = student.call_duration || "00:00:00.000000";
      const [hours, minutes, seconds] = callDuration
        .split(".")[0]
        .split(":")
        .map((part) => part.padStart(2, "0"));
      setInitialStatus(student.is_interested || "");

      const standardInterests = [
        "Not Interested",
        "Interested",
        "Most Interested",
        "Call Back",
      ];
      let interestStatus = student.is_interested || "";
      let otherReasonValue = "";

      if (interestStatus && !standardInterests.includes(interestStatus)) {
        otherReasonValue = interestStatus;
        interestStatus = "Others";
      }

      setCurrentStudent(student);

      if (student.follow_up_date && !String(student.follow_up_date).startsWith("0000")) {
        const parsed = dayjs(student.follow_up_date);
        setFollowUpDateTime(parsed.isValid() ? parsed : null);
      } else {
        setFollowUpDateTime(null);
      }

      setFormData({
        student_name: student.student_name || "",
        employee_student_id: student.employee_student_id || "",
        gender: student.gender || "",
        father_name: student.father_name || "",
        employee_id: student.employee_id || "",
        district: student.district || "",
        city: student.city || "",
        address: student.address || "",
        call_duration: student.call_duration || "00:00:00.000000",
        code: student.code || "",
        clg_name: student.clg_name || "",
        course: student.course || "",
        year: student.year || "",
        mobile_number1: student.mobile_number || "N/A",
        mobile_number2: student.mobile_number2 || "N/A",
        email: student.email || "",
        aadhar_number: student.aadhar_number || "",
        state: student.state || "",
        pincode: student.pincode || "",
        inter_percentage: student.inter_percentage || "",
        program_type: student.program_type || "UG",
        is_digital_lead: student.is_digital_lead || "0",
        lead_type:
          student.lead_type ||
          (String(student.is_digital_lead) === "1" ? "Digital Lead" : "Direct Lead"),
        call_status: student.call_status || "",
        is_interested: interestStatus,
        call_back_reason: student.call_back_reason || "",
        other_reasons: otherReasonValue,
        remarks: student.remarks || "",
        is_follow_up: student.is_follow_up || false,
        is_active: student.is_active || false,
        created_date: student.created_date || "",
        follow_up_date: student.follow_up_date || "",
        native_district: student.native_district || "",
        native_address: student.native_address || "",
        other_universities: student.other_universities || "",
        other_state: student.other_state || "",
        hours,
        minutes,
        seconds,
      });

      if (student.ug_pg_course) {
        setSelectedCourses(
          student.ug_pg_course.split(", ").filter((c) => c !== "")
        );
      } else {
        setSelectedCourses([]);
      }
    } else {
      setFormData({
        student_name: "",
        father_name: "",
        employee_student_id: "",
        gender: "Male",
        employee_id: "",
        district: "",
        city: "",
        address: "",
        call_duration: "00:00:00.000000",
        code: "",
        clg_name: "",
        course: "",
        year: "",
        mobile_number1: "",
        mobile_number2: "",
        email: "",
        aadhar_number: "",
        state: "",
        pincode: "",
        inter_percentage: "",
        program_type: "Full-time",
        is_digital_lead: "0",
        lead_type: "",
        call_status: "",
        call_back_reason: "",
        other_reasons: "",
        is_interested: "",
        remarks: "",
        is_follow_up: false,
        is_active: false,
        created_date: "",
        follow_up_date: "",
        native_district: "",
        native_address: "",
        other_universities: "",
        other_state: "",
        hours: "00",
        minutes: "00",
        seconds: "00",
      });
      setFollowUpDateTime(null);
    }
    setModalVisible(true);
  };

  const handleCloseModal = async () => {
    const currentDateTime = getFormattedISTTime();
    setOutTime(currentDateTime);
    setModalVisible(false);
    setCurrentStudent(null);
    setSelectedCourses([]);
    setSelectedChecklist([]);
    setChecklistDropdown("");
    setFollowUpDateTime(null);
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name === "call_status" && (value === "Not Answered" || value === "")) {
      setFormData((prev) => ({
        ...prev,
        is_interested: "",
        [name]: value,
      }));
    } else if (name === "is_interested") {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
        ...(value !== "Call Back" && { call_back_reason: "" }),
        ...(value !== "Others" && { other_reasons: "" }),
      }));
    } else if (name === "program_type" && (value === "PG" || value === "")) {
      setSelectedCourses([]);
      setDropdownValue("");
      setFormData((prev) => ({
        ...prev,
        [name]: type === "checkbox" ? checked : value,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: type === "checkbox" ? checked : value,
      }));
    }
  };

  const handleSelectChange = (e) => {
    const selectedCourse = e.target.value;
    if (selectedCourse && !selectedCourses.includes(selectedCourse)) {
      setSelectedCourses((prev) => [...prev, selectedCourse]);
    }
    setDropdownValue("");
  };

  const handleChecklistSelect = (e) => {
    const id = Number(e.target.value);
    if (id && !selectedChecklist.includes(id)) {
      setSelectedChecklist((prev) => [...prev, id]);
    }
    setChecklistDropdown("");
  };

  const handleRemoveChecklist = (id) => {
    setSelectedChecklist((prev) => prev.filter((x) => x !== id));
  };

  const handleRemoveTag = (course) => {
    setSelectedCourses((prev) => prev.filter((c) => c !== course));
  };

  const courses =
    formData.program_type === "UG"
      ? ugCourses
      : formData.program_type === "PG"
        ? pgCourses
        : [];

  const headers = {
    Authorization: "Bearer sandeep_university_916",
    "Content-Type": "application/json",
  };

  const handleSave = async (e) => {
    setLoadingSubmit(true);
    e.preventDefault();

    if (!validateForm()) {
      setLoadingSubmit(false);
      return;
    }

    try {
      const encodedEmployeeId = sessionStorage.getItem("H7Z4L9VD2XK5JW8QRYT6");
      if (!encodedEmployeeId) {
        throw new Error("Employee ID not found in session storage");
      }
      const decodedEmployeeId = atob(encodedEmployeeId);

      const computedLeadType =
        formData.lead_type ||
        (String(formData.is_digital_lead) === "1" ? "Digital Lead" : "Direct Lead");

      const payload = {
        employee_student_id: formData.employee_student_id || "",
        employee_id: decodedEmployeeId || "",
        student_name: formData.student_name || "",
        last_name: "",
        gender: formData.gender || "",
        father_name: formData.father_name || "",
        mobile_number1: formData.mobile_number1 || "N/A",
        mobile_number2: formData.mobile_number2 || "N/A",
        email: formData.email || "",
        aadhar_number: formData.aadhar_number || "",
        state: formData.state || "",
        district: formData.district || "",
        city: formData.city || "",
        address: formData.address || "",
        call_duration: timer,
        pincode: formData.pincode || "",
        course: formData.course || "",
        clg_name: formData.clg_name || "",
        inter_percentage: formData.inter_percentage || "",
        program_type: formData.program_type || "",
        is_digital_lead: formData.is_digital_lead || "0",
        lead_type: computedLeadType,
        ug_pg_course: selectedCourses.join(", "),
        call_status: formData.call_status || "",
        remarks: formData.remarks || "",
        is_interested:
          formData.is_interested === "Others"
            ? formData.other_reasons
            : formData.is_interested,
        call_back_reason: formData.call_back_reason || "",
        other_universities: formData.other_universities || "",
        other_state: formData.other_state || "",
        follow_up_date: new Date(),
        native_district: formData.native_district || "N/A",
        native_address: formData.native_address
      };




      if (followUpDateTime && followUpDateTime.isValid()) {
        payload.next_follow_up_date = followUpDateTime.format("YYYY-MM-DD HH:mm:ss");
      }

      const response = await fetch(SummaryApi.uploadStudent.url, {
        method: SummaryApi.uploadStudent.method,
        headers: headers,
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const result = await response.json();
      if (result.status) {
        toast.success("Student added successfully!");
        const studentId = result.student_id;

        if (formData.call_status === "Contacted" && checklistItems.length > 0) {
          try {
            await fetch(SummaryApi.saveChecklistStatus.url, {
              method: SummaryApi.saveChecklistStatus.method.toUpperCase(),
              headers: headers,
              body: JSON.stringify({
                student_id: studentId,
                respondent_type: "parent",
                checklist: checklistItems.map((item) => ({
                  checklist_id: item.checklist_id,
                  status: selectedChecklist.includes(item.checklist_id)
                    ? "completed"
                    : "pending",
                })),
              }),
            });
          } catch (err) {
            // Checklist save handling
          }
        }

        const currentDateTime = getFormattedISTTime();
        setOutTime(currentDateTime);

        const callLogPayload = {
          employee_id: formData.employee_id,
          student_id: studentId,
          in_time: inTime,
          out_time: currentDateTime,
          call_duration: timer,
          remarks: formData.remarks || "",
        };

        const callLogResponse = await fetch(
          SummaryApi.calllogsstudentcreate.url,
          {
            method: SummaryApi.calllogsstudentcreate.method,
            headers: {
              Authorization: "Bearer sandeep_university_916",
              "Content-Type": "application/json",
            },
            body: JSON.stringify(callLogPayload),
          }
        );

        const callLogResult = await callLogResponse.json();
        if (!callLogResult.status) {
          toast.error("Failed to create call log.");
        }

        handleCloseModal();
        fetchData();
      } else {
        toast.error(result.message);
      }
    } catch (err) {
      console.error("Error during save process:", err);
    } finally {
      setLoadingSubmit(false);
    }
  };

  const inputClass =
    "mt-1.5 w-full rounded-lg border border-gray-300 bg-white " +
    "px-3 py-2 text-sm text-gray-800 outline-none transition " +
    "placeholder:text-gray-400 hover:border-gray-400 " +
    "focus:border-[#172C57] focus:ring-2 focus:ring-[#172C57] " +
    "disabled:cursor-not-allowed disabled:bg-gray-100 disabled:text-gray-500";

  const labelClass = "text-sm font-semibold";
  const labelStyle = { color: THEME.primary };

  return (
    <div className="min-h-auto w-full">
      <div className="w-full space-y-5">
        {loadingSubmit && (
          <div className="fixed inset-0 bg-black bg-opacity-50 z-[60] flex justify-center items-center">
            <span className="text-white text-lg">Submitting...</span>
          </div>
        )}

        <h1
          className="text-2xl md:text-3xl font-bold"
          style={{ color: THEME.primary }}
        >
          Today's Task
        </h1>

        {/* Summary Section */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          <div className="flex items-center gap-4 rounded-xl border border-slate-200 bg-green-50 p-4 shadow-sm">
            <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-green-100 text-green-600">
              <FaCheckCircle className="text-2xl" />
            </div>
            <div>
              <p className="text-sm font-semibold text-gray-600">
                Today Task Followed Up
              </p>
              <p
                className="text-2xl font-bold"
                style={{ color: THEME.primary }}
              >
                {todayTaskfollowedUpCount}
              </p>
            </div>
          </div>

          <div className="flex items-center gap-4 rounded-xl border border-slate-200 bg-blue-50 p-4 shadow-sm">
            <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-blue-100 text-blue-600">
              <FaCheckCircle className="text-2xl" />
            </div>
            <div>
              <p className="text-sm font-semibold text-gray-600">
                Previous Task Followed Up
              </p>
              <p
                className="text-2xl font-bold"
                style={{ color: THEME.primary }}
              >
                {previousTaskfollowedUpCount}
              </p>
            </div>
          </div>

          <div className="flex items-center gap-4 rounded-xl border border-slate-200 bg-amber-50 p-4 shadow-sm">
            <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-amber-100 text-amber-600">
              <FaTimesCircle className="text-2xl" />
            </div>
            <div>
              <p className="text-sm font-semibold text-gray-600">
                Today Not Followed Up
              </p>
              <p
                className="text-2xl font-bold"
                style={{ color: THEME.primary }}
              >
                {taskTodayNotFollowedUpCount}
              </p>
            </div>
          </div>

          <div className="flex items-center gap-4 rounded-xl border border-slate-200 bg-red-50 p-4 shadow-sm">
            <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-red-100 text-red-600">
              <FaTimesCircle className="text-2xl" />
            </div>
            <div>
              <p className="text-sm font-semibold text-gray-600">
                Previous Not Followed Up
              </p>
              <p
                className="text-2xl font-bold"
                style={{ color: THEME.primary }}
              >
                {taskPreviousNotFollowedUpCount}
              </p>
            </div>
          </div>
        </div>

        <div className="overflow-x-auto rounded-xl border border-slate-200 bg-white shadow-sm">
          <table className="min-w-full">
            <thead className="bg-gray-200">
              <tr>
                {columns.map((column) => (
                  <th
                    key={column.accessor}
                    className={`px-4 py-2 text-left font-semibold whitespace-nowrap ${STICKY_ACCESSORS.includes(column.accessor)
                      ? "sticky right-0 z-20 bg-gray-200 shadow-[-4px_0_6px_-4px_rgba(0,0,0,0.15)]"
                      : ""
                      }`}
                    style={{ color: THEME.primary }}
                  >
                    {column.Header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {loading
                ? Array.from({ length: 10 }).map((_, index) => (
                  <tr key={index}>
                    <td colSpan={columns.length} className="px-4 py-1">
                      <div className="animate-pulse">
                        <div className="h-10 w-full rounded bg-gray-200"></div>
                      </div>
                    </td>
                  </tr>
                ))
                : currentData.map((row, index) => {
                  const currentDate = getCurrentDate();
                  const isEnrolledRow = (r) => String(r.is_follow_up) === "1";
                  const createdDate = row.created_date ? row.created_date.split(" ")[0] : "";

                  const followed = isEnrolledRow(row);
                  const isToday = currentDate === createdDate;

                  let rowColor;
                  let hoverColor;
                  if (followed) {
                    rowColor = isToday ? "bg-green-100" : "bg-yellow-50";
                    hoverColor = isToday
                      ? "hover:bg-green-200"
                      : "hover:bg-yellow-100";
                  } else {
                    rowColor = isToday ? "bg-white" : "bg-red-50";
                    hoverColor = isToday
                      ? "hover:bg-gray-50"
                      : "hover:bg-red-100";
                  }

                  if (currentDate !== createdDate && row.is_follow_up === "0") {
                    rowColor = "bg-red-50";
                    hoverColor = "hover:bg-red-100";
                  } else if (
                    currentDate !== createdDate &&
                    row.is_follow_up === "1"
                  ) {
                    rowColor = "bg-yellow-50";
                    hoverColor = "hover:bg-yellow-100";
                  } else if (
                    currentDate === createdDate &&
                    row.is_follow_up === "1"
                  ) {
                    rowColor = "bg-green-100";
                    hoverColor = "hover:bg-green-200";
                  } else if (
                    currentDate === createdDate &&
                    row.is_follow_up === "0"
                  ) {
                    rowColor = "bg-white";
                    hoverColor = "hover:bg-gray-50";
                  }

                  return (
                    <tr
                      key={index}
                      className={`group/row border-b border-slate-100 transition ${hoverColor} ${rowColor}`}
                    >
                      {columns.map((column) => (
                        <td
                          key={column.accessor}
                          className={`px-4 py-2 text-left text-sm text-slate-700 whitespace-nowrap ${STICKY_ACCESSORS.includes(column.accessor)
                            ? `sticky right-0 z-10 ${getStickyCellBg(
                              rowColor,
                              hoverColor
                            )} shadow-[-4px_0_6px_-4px_rgba(0,0,0,0.15)]`
                            : ""
                            }`}
                        >
                          {column.accessor === "edit" ? (
                            isEnrolledRow(row) ? (
                              <span className="inline-flex items-center px-3 py-1 text-sm font-semibold text-green-700 bg-green-100 border border-green-300 rounded-full">
                                Enrolled
                              </span>
                            ) : (
                              <button
                                onClick={() => handleOpenModal(row)}
                                style={{ backgroundColor: THEME.actionBlue }}
                                onMouseEnter={(e) =>
                                (e.currentTarget.style.backgroundColor =
                                  THEME.actionBlueHover)
                                }
                                onMouseLeave={(e) =>
                                (e.currentTarget.style.backgroundColor =
                                  THEME.actionBlue)
                                }
                                className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-lg px-3 py-1.5 text-sm font-semibold text-white shadow-sm transition"
                              >
                                Enroll
                              </button>
                            )
                          ) : column.accessor === "task_date" ? (
                            <span>{formatDate(row.created_date)}</span>
                          ) : column.accessor === "follow_date" ? (
                            <span>
                              {formatDate(row.follow_up_date, row.is_follow_up)}
                            </span>
                          ) : column.accessor === "clg_name" ? (
                            <div className="group relative">
                              <span>
                                {row[column.accessor]?.length > 10
                                  ? `${row[column.accessor].slice(0, 10)}...`
                                  : row[column.accessor]}
                              </span>

                              {row[column.accessor]?.length > 10 && (
                                <div className="absolute z-50 hidden group-hover:block bg-black text-white text-xs rounded px-2 py-1 whitespace-nowrap left-0 top-6 shadow-lg">
                                  {row[column.accessor]}
                                </div>
                              )}
                            </div>
                          ) : column.accessor === "is_digital_lead" ? (
                            row.is_digital_lead === "1" ? (
                              <span className="px-2 py-1 rounded-full text-xs font-semibold">
                                Digital Leads
                              </span>
                            ) : (
                              <span className="px-2 py-1 rounded-full text-gray-500 text-xs font-semibold">
                                N/A
                              </span>
                            )
                          ) : (
                            row[column.accessor]
                          )}
                        </td>
                      ))}
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>

        {/* Pagination Controls */}
        <div className="flex justify-between items-center">
          <div className="flex items-center">
            <span className="text-gray-600 text-sm">
              Showing{" "}
              <span className="font-semibold" style={{ color: THEME.primary }}>
                {displayStart}
              </span>{" "}
              to{" "}
              <span className="font-semibold" style={{ color: THEME.primary }}>
                {displayEnd}
              </span>{" "}
              of{" "}
              <span className="font-semibold" style={{ color: THEME.primary }}>
                {studentsData.length}
              </span>{" "}
              entries
            </span>
          </div>

          <div className="flex items-center space-x-2">
            <button
              className="rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm font-semibold text-[#172C57] transition hover:bg-gray-50 disabled:cursor-not-allowed disabled:bg-gray-100 disabled:text-gray-400"
              onClick={() => setPageIndex(0)}
              disabled={pageIndex === 0}
            >
              {"<<"}
            </button>
            <button
              className="rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm font-semibold text-[#172C57] transition hover:bg-gray-50 disabled:cursor-not-allowed disabled:bg-gray-100 disabled:text-gray-400"
              onClick={() => setPageIndex(Math.max(0, pageIndex - 1))}
              disabled={pageIndex === 0}
            >
              {"<"}
            </button>
            <span
              className="rounded-lg px-3 py-2 text-sm font-semibold text-white"
              style={{ backgroundColor: THEME.primary }}
            >
              Page {pageIndex + 1} of {pageCount}
            </span>
            <button
              className="rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm font-semibold text-[#172C57] transition hover:bg-gray-50 disabled:cursor-not-allowed disabled:bg-gray-100 disabled:text-gray-400"
              onClick={() => setPageIndex(Math.min(pageCount - 1, pageIndex + 1))}
              disabled={pageIndex === pageCount - 1}
            >
              {">"}
            </button>
            <button
              className="rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm font-semibold text-[#172C57] transition hover:bg-gray-50 disabled:cursor-not-allowed disabled:bg-gray-100 disabled:text-gray-400"
              onClick={() => setPageIndex(pageCount - 1)}
              disabled={pageIndex === pageCount - 1}
            >
              {">>"}
            </button>

            <select
              className="rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm font-semibold text-[#172C57] outline-none focus:border-[#172C57] focus:ring-2 focus:ring-[#172C57]"
              value={pageSize}
              onChange={(e) => setPageSize(Number(e.target.value))}
            >
              {[10, 20, 30, 40].map((size) => (
                <option key={size} value={size}>
                  Show {size}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* Modal Component */}
        <Modal
          isOpen={modalVisible}
          onRequestClose={handleCloseModal}
          contentLabel="Student Enrollment Details"
          className="mx-auto my-10 mt-[100px] flex max-h-[calc(100vh-140px)] w-full max-w-4xl flex-col overflow-hidden rounded-xl bg-white shadow-2xl outline-none"
          overlayClassName="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-2 sm:p-4"
        >
          {/* ================= HEADER ================= */}
          <div className="sticky top-0 z-10 shrink-0 border-b border-slate-100 bg-white px-5 py-4 sm:px-6">
            <div className="flex items-center justify-between gap-4">
              <div className="flex items-center gap-4">
                <div
                  className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl"
                  style={{ backgroundColor: THEME.primaryLight }}
                >
                  <span className="text-2xl">🎓</span>
                </div>

                <div>
                  <h2
                    className="text-xl font-bold sm:text-2xl"
                    style={{ color: THEME.primary }}
                  >
                    Student Enrollment
                  </h2>
                  <p className="mt-1 text-sm text-gray-500">
                    Manage student information, education and call follow-ups
                  </p>
                </div>
              </div>

              <button
                type="button"
                onClick={handleCloseModal}
                aria-label="Close modal"
                className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg text-2xl text-gray-500 transition hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-[#172C57]"
              >
                ×
              </button>
            </div>
          </div>

          {/* ================= FORM ================= */}
          <form
            onSubmit={handleSave}
            className="min-h-0 flex-1 overflow-y-auto"
          >
            <div className="space-y-5 p-5 sm:p-6">
              {/* TOP TIMER & CALL STUDENT BAR */}
              <div className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
                <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                  {/* Timer */}
                  <div className="flex items-center gap-3">
                    <div className="flex h-11 w-11 items-center justify-center rounded-full bg-blue-50 text-blue-600">
                      <IoCall className="text-xl" />
                    </div>

                    <div>
                      <p className="text-xs font-medium text-gray-500">
                        Call Duration
                      </p>
                      <div className="flex items-center gap-2">
                        <span className="h-2 w-2 animate-pulse rounded-full bg-green-500" />
                        <span
                          className="font-mono text-2xl font-bold tabular-nums"
                          style={{ color: THEME.primary }}
                        >
                          {timer}
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Call Student */}
                  <a
                    href={
                      formData.mobile_number1
                        ? `tel:${formData.mobile_number1}`
                        : undefined
                    }
                    onClick={(e) => {
                      if (!formData.mobile_number1) {
                        e.preventDefault();
                        alert("Student mobile number is not available.");
                      }
                    }}
                    style={{
                      backgroundColor: formData.mobile_number1
                        ? THEME.actionGreen
                        : THEME.disabledGray,
                    }}
                    onMouseEnter={(e) => {
                      if (formData.mobile_number1)
                        e.currentTarget.style.backgroundColor = THEME.actionGreenHover;
                    }}
                    onMouseLeave={(e) => {
                      if (formData.mobile_number1)
                        e.currentTarget.style.backgroundColor = THEME.actionGreen;
                    }}
                    className={`inline-flex items-center justify-center gap-3 whitespace-nowrap rounded-lg px-5 py-2.5 text-sm font-semibold text-white shadow-sm transition ${formData.mobile_number1 ? "" : "cursor-not-allowed"
                      }`}
                  >
                    <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-white/20">
                      <IoCall className="text-xl" />
                    </span>

                    <span className="text-left">
                      <span className="block text-xs font-medium text-white/80">
                        Call Student
                      </span>
                      <span className="block text-base font-bold">
                        {formData.mobile_number1 || "No number available"}
                      </span>
                    </span>
                  </a>
                </div>
              </div>

              {/* PERSONAL INFORMATION */}
              <section className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm">
                <div className="mb-5 flex items-center gap-3 border-b border-slate-100 pb-4">
                  <div className="flex h-10 w-10 items-center justify-center rounded-full bg-blue-50 text-xl">
                    👤
                  </div>
                  <div>
                    <h3 className="text-sm font-bold" style={{ color: THEME.primary }}>
                      Personal Information
                    </h3>
                    <p className="text-xs text-gray-500">
                      Basic student and guardian details
                    </p>
                  </div>
                </div>

                <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
                  <div>
                    <label htmlFor="student_name" className={labelClass} style={labelStyle}>
                      Student Name <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      id="student_name"
                      name="student_name"
                      value={formData.student_name}
                      onChange={handleChange}
                      placeholder="Enter student name"
                      className={inputClass}
                      required
                    />
                  </div>

                  <div>
                    <label htmlFor="gender" className={labelClass} style={labelStyle}>
                      Gender
                    </label>
                    <select
                      id="gender"
                      name="gender"
                      value={formData.gender}
                      onChange={handleChange}
                      className={inputClass}
                    >
                      <option value="">Select Gender</option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>

                  <div>
                    <label htmlFor="father_name" className={labelClass} style={labelStyle}>
                      Father / Guardian Name
                    </label>
                    <input
                      type="text"
                      id="father_name"
                      name="father_name"
                      value={formData.father_name}
                      onChange={handleChange}
                      placeholder="Enter guardian name"
                      className={inputClass}
                    />
                  </div>

                  <div>
                    <label htmlFor="mobile_number" className={labelClass} style={labelStyle}>
                      Mobile Number 1 <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="tel"
                      id="mobile_number"
                      name="mobile_number"
                      value={formData.mobile_number1}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d*$/.test(value) && value.length <= 10) {
                          setFormData((prev) => ({
                            ...prev,
                            mobile_number1: value,
                          }));
                        }
                      }}
                      placeholder="10-digit mobile number"
                      className={inputClass}
                      required
                      pattern="\d{10}"
                      disabled={true}
                      maxLength={10}
                      title="Mobile number must be exactly 10 digits."
                    />
                  </div>

                  <div>
                    <label htmlFor="mobile_number2" className={labelClass} style={labelStyle}>
                      Mobile Number 2
                    </label>
                    <input
                      type="tel"
                      id="mobile_number2"
                      name="mobile_number2"
                      value={formData.mobile_number2}
                      onChange={handleChange}
                      placeholder="Alternate mobile number"
                      className={inputClass}
                    />
                  </div>

                  <div>
                    <label htmlFor="email" className={labelClass} style={labelStyle}>
                      Email Address
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="student@example.com"
                      className={inputClass}
                    />
                  </div>

                  <div>
                    <label htmlFor="aadhar_number" className={labelClass} style={labelStyle}>
                      Aadhaar Number
                    </label>
                    <input
                      type="text"
                      id="aadhar_number"
                      name="aadhar_number"
                      value={formData.aadhar_number}
                      onChange={(e) => {
                        const rawValue = e.target.value.replace(/\D/g, "").slice(0, 12);
                        const formattedValue = rawValue.replace(/(\d{4})(?=\d)/g, "$1-");
                        setFormData((prev) => ({
                          ...prev,
                          aadhar_number: formattedValue,
                        }));
                      }}
                      placeholder="XXXX-XXXX-XXXX"
                      className={inputClass}
                      maxLength={14}
                      pattern="\d{4}-\d{4}-\d{4}"
                      title="Enter 12 digits in the format 1234-5678-9012."
                    />
                  </div>
                </div>
              </section>

              {/* ADDRESS INFORMATION */}
              <section className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm">
                <div className="mb-5 flex items-center gap-3 border-b border-slate-100 pb-4">
                  <div className="flex h-10 w-10 items-center justify-center rounded-full bg-purple-50 text-xl">
                    📍
                  </div>
                  <div>
                    <h3 className="text-sm font-bold" style={{ color: THEME.primary }}>
                      Address Information
                    </h3>
                    <p className="text-xs text-gray-500">Current and native address details</p>
                  </div>
                </div>

                <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
                  <div>
                    <label htmlFor="state" className={labelClass} style={labelStyle}>
                      State
                    </label>
                    <input
                      id="state"
                      name="state"
                      value={formData.state}
                      onChange={handleChange}
                      placeholder="Enter state"
                      className={inputClass}
                    />
                  </div>

                  <div>
                    <label htmlFor="district" className={labelClass} style={labelStyle}>
                      District
                    </label>
                    <select
                      id="district"
                      name="district"
                      value={formData.district}
                      onChange={handleChange}
                      className={inputClass}
                      disabled
                    >
                      <option value="">Select District</option>
                      {districtOptions.map((district, index) => (
                        <option key={index} value={district}>
                          {district}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div>
                    <label htmlFor="city" className={labelClass} style={labelStyle}>
                      City
                    </label>
                    <input
                      id="city"
                      name="city"
                      value={formData.city}
                      onChange={handleChange}
                      placeholder="Enter city"
                      className={inputClass}
                    />
                  </div>

                  <div>
                    <label htmlFor="address" className={labelClass} style={labelStyle}>
                      Address
                    </label>
                    <input
                      id="address"
                      name="address"
                      value={formData.address}
                      onChange={handleChange}
                      placeholder="Enter current address"
                      className={inputClass}
                    />
                  </div>

                  <div>
                    <label htmlFor="pincode" className={labelClass} style={labelStyle}>
                      Pincode
                    </label>
                    <input
                      type="text"
                      id="pincode"
                      name="pincode"
                      value={formData.pincode}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d*$/.test(value) && value.length <= 6) {
                          setFormData((prev) => ({
                            ...prev,
                            pincode: value,
                          }));
                        }
                      }}
                      placeholder="6-digit pincode"
                      className={inputClass}
                      maxLength={6}
                      pattern="\d{6}"
                      title="Pincode must be exactly 6 digits."
                    />
                  </div>

                  <div>
                    <label htmlFor="native_district" className={labelClass} style={labelStyle}>
                      Native District
                    </label>
                    <input
                      id="native_district"
                      name="native_district"
                      value={formData.native_district}
                      onChange={handleChange}
                      placeholder="Enter native district"
                      className={inputClass}
                    />
                  </div>

                  <div className="sm:col-span-2 lg:col-span-3">
                    <label htmlFor="native_address" className={labelClass} style={labelStyle}>
                      Native Address
                    </label>
                    <input
                      id="native_address"
                      name="native_address"
                      value={formData.native_address}
                      onChange={handleChange}
                      placeholder="Enter native address"
                      className={inputClass}
                    />
                  </div>
                </div>
              </section>

              {/* EDUCATION INFORMATION */}
              <section className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm">
                <div className="mb-5 flex items-center gap-3 border-b border-slate-100 pb-4">
                  <div className="flex h-10 w-10 items-center justify-center rounded-full bg-green-50 text-xl">
                    🎓
                  </div>
                  <div>
                    <h3 className="text-sm font-bold" style={{ color: THEME.primary }}>
                      Education Information
                    </h3>
                    <p className="text-xs text-gray-500">College, courses and academic details</p>
                  </div>
                </div>

                <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
                  <div>
                    <label htmlFor="clg_name" className={labelClass} style={labelStyle}>
                      College
                    </label>
                    <input
                      id="clg_name"
                      name="clg_name"
                      value={formData.clg_name}
                      onChange={handleChange}
                      placeholder="Enter college name"
                      className={inputClass}
                    />
                  </div>

                  <div>
                    <label htmlFor="course" className={labelClass} style={labelStyle}>
                      Course
                    </label>
                    <input
                      id="course"
                      name="course"
                      value={formData.course}
                      onChange={handleChange}
                      placeholder="Enter course"
                      className={inputClass}
                    />
                  </div>

                  <div>
                    <label htmlFor="program_type" className={labelClass} style={labelStyle}>
                      Program Type
                    </label>
                    <select
                      id="program_type"
                      name="program_type"
                      value={formData.program_type}
                      onChange={handleChange}
                      className={inputClass}
                    >
                      <option value="">Select Program Type</option>
                      <option value="UG">UG</option>
                      <option value="PG">PG</option>
                    </select>
                  </div>

                  <div>
                    <label htmlFor="inter_percentage" className={labelClass} style={labelStyle}>
                      Intermediate Percentage / CGPA
                    </label>
                    <input
                      id="inter_percentage"
                      name="inter_percentage"
                      value={formData.inter_percentage}
                      onChange={handleChange}
                      placeholder="Enter percentage or CGPA"
                      className={inputClass}
                    />
                  </div>

                  <div className="sm:col-span-2 lg:col-span-3">
                    <label className={labelClass} style={labelStyle}>
                      UG / PG Courses
                    </label>
                    <select
                      id="ug_pg_course"
                      name="ug_pg_course"
                      value={dropdownValue}
                      onChange={handleSelectChange}
                      className={inputClass}
                    >
                      <option value="">Select a course to add</option>
                      {courses.map((course) => (
                        <option key={course} value={course}>
                          {course}
                        </option>
                      ))}
                    </select>

                    <div className="mt-3 flex flex-wrap gap-2">
                      {selectedCourses.map((course) => (
                        <span
                          key={course}
                          className="inline-flex items-center gap-2 rounded-full border border-blue-200 bg-blue-50 px-3 py-1.5 text-sm font-medium text-blue-800"
                        >
                          {course}
                          <button
                            type="button"
                            aria-label={`Remove ${course}`}
                            onClick={() => handleRemoveTag(course)}
                            className="text-blue-700 hover:text-red-600"
                          >
                            <IoIosCloseCircle className="h-5 w-5" />
                          </button>
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              </section>

              {/* CHECKLIST INFORMATION */}
              {/* <section className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm">
                <div className="mb-4 flex items-center gap-3">
                  <div className="flex h-10 w-10 items-center justify-center rounded-full bg-yellow-50 text-xl">
                    ☑️
                  </div>
                  <div>
                    <h3 className="text-sm font-bold" style={{ color: THEME.primary }}>
                      Parent Checklist
                    </h3>
                    <p className="text-xs text-gray-500">
                      Selected checklist items
                    </p>
                  </div>
                </div>

                <div className="flex flex-wrap gap-2">
                  {selectedChecklist.length === 0 && (
                    <p className="text-sm text-gray-400">
                      No checklist items selected
                    </p>
                  )}

                  {selectedChecklist.map((id) => {
                    const item = checklistItems.find(
                      (i) => String(i.checklist_id) === String(id)
                    );

                    return (
                      <span
                        key={id}
                        className="inline-flex items-center gap-2 rounded-full border border-green-200 bg-green-50 px-3 py-1.5 text-sm font-medium text-green-700"
                      >
                        {item ? item.checklist_name : id}
                        <button
                          type="button"
                          aria-label="Remove checklist item"
                          onClick={() => handleRemoveChecklist(id)}
                          className="text-green-700 hover:text-red-600"
                        >
                          <IoIosCloseCircle className="h-5 w-5" />
                        </button>
                      </span>
                    );
                  })}
                </div>
              </section> */}

              {/* CALL FOLLOW-UP */}
              <section className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm">
                <div className="mb-5 flex items-center gap-3 border-b border-slate-100 pb-4">
                  <div className="flex h-10 w-10 items-center justify-center rounded-full bg-amber-50 text-amber-600">
                    <IoCall className="text-xl" />
                  </div>
                  <div>
                    <h3 className="text-sm font-bold" style={{ color: THEME.primary }}>
                      Call & Follow-up
                    </h3>
                    <p className="text-xs text-gray-500">
                      Record the call outcome and the student's interest
                    </p>
                  </div>
                </div>

                <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
                  <div>
                    <label htmlFor="call_status" className={labelClass} style={labelStyle}>
                      Call Status <span className="text-red-500">*</span>
                    </label>
                    <select
                      id="call_status"
                      name="call_status"
                      value={formData.call_status}
                      onChange={handleChange}
                      className={inputClass}
                      required
                      disabled={
                        initialStatus === "Interested" ||
                        initialStatus === "Most Interested"
                      }
                    >
                      <option value="">Select Status</option>
                      <option value="Contacted">Contacted</option>
                      <option
                        value="Not Answered"
                        disabled={initialStatus === "Call Back"}
                      >
                        Not Answered
                      </option>
                    </select>
                  </div>

                  <div>
                    <label htmlFor="remarks" className={labelClass} style={labelStyle}>
                      Remarks
                    </label>
                    <textarea
                      id="remarks"
                      name="remarks"
                      value={formData.remarks}
                      onChange={handleChange}
                      placeholder="Add call notes or follow-up information..."
                      className={inputClass}
                      rows={3}
                    />
                  </div>

                  {/* FOLLOW UP DATE & TIME */}
                  <div className="mt-5">
                    <label htmlFor="follow_up_date" className={labelClass} style={labelStyle}>
                      Follow Up Date &amp; Time <span className="text-gray-400 font-normal">(optional)</span>
                    </label>
                    <DatePicker
                      id="follow_up_date"
                      format="DD-MM-YYYY hh:mm A"
                      value={followUpDateTime}
                      onChange={(val) => setFollowUpDateTime(val)}
                      showTime={SHOW_TIME_CONFIG}
                      disabledDate={disabledDate}
                      disabledTime={disabledTime}
                      placeholder="Select date and time"
                      allowClear
                      className="mt-1.5 w-full"
                      style={{ width: "100%" }}
                      inputReadOnly={false}
                      needConfirm={false}
                      getPopupContainer={() => document.body}
                    />

                    <p className="mt-1 text-xs text-gray-500">
                      Only today and future dates can be selected. Leave empty to skip.
                    </p>
                  </div>
                </div>

                <div className="mt-5">
                  <p className="mb-3 text-sm font-semibold" style={{ color: THEME.primary }}>
                    Student Interest Level
                  </p>

                  <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
                    {[
                      {
                        value: "Not Interested",
                        color: "border-red-200 bg-red-100 text-red-700",
                        disabled:
                          formData.call_status !== "Contacted" ||
                          initialStatus === "Interested" ||
                          initialStatus === "Most Interested",
                      },
                      {
                        value: "Interested",
                        color: "border-yellow-200 bg-yellow-100 text-yellow-700",
                        disabled:
                          formData.call_status !== "Contacted" ||
                          initialStatus === "Most Interested",
                      },
                      {
                        value: "Most Interested",
                        color: "border-green-200 bg-green-100 text-green-700",
                        disabled: formData.call_status !== "Contacted",
                      },
                      {
                        value: "Call Back",
                        color: "border-blue-200 bg-blue-50 text-blue-600",
                        disabled:
                          formData.call_status !== "Contacted" ||
                          initialStatus === "Interested" ||
                          initialStatus === "Most Interested",
                      },
                      {
                        value: "Others",
                        color: "border-gray-200 bg-gray-100 text-gray-600",
                        disabled:
                          formData.call_status !== "Contacted" ||
                          initialStatus === "Interested" ||
                          initialStatus === "Most Interested" ||
                          initialStatus === "Call Back",
                      },
                    ].map((option) => (
                      <label
                        key={option.value}
                        className={`flex items-center gap-3 rounded-lg border p-3 text-sm font-medium transition ${option.color
                          } ${formData.is_interested === option.value
                            ? "ring-2 ring-[#172C57] ring-offset-1"
                            : ""
                          } ${option.disabled
                            ? "cursor-not-allowed opacity-50"
                            : "cursor-pointer hover:shadow-sm"
                          }`}
                      >
                        <input
                          type="radio"
                          name="is_interested"
                          value={option.value}
                          checked={formData.is_interested === option.value}
                          onChange={handleChange}
                          disabled={option.disabled}
                          className="h-4 w-4 accent-[#172C57]"
                        />
                        {option.value}
                      </label>
                    ))}
                  </div>
                </div>

                {/* CALLBACK REASON */}
                {formData.is_interested === "Call Back" && (
                  <div className="mt-5 rounded-lg border border-slate-200 bg-gray-50 p-4">
                    <label htmlFor="call_back_reason" className={labelClass} style={labelStyle}>
                      Call Back Reason <span className="text-red-500">*</span>
                    </label>
                    <select
                      id="call_back_reason"
                      name="call_back_reason"
                      value={formData.call_back_reason || ""}
                      onChange={handleChange}
                      className={inputClass}
                      required
                    >
                      <option value="">Select Reason</option>
                      <option value="IPE Exams">IPE Exams</option>
                      <option value="Jee Mains Results">JEE Mains Results</option>
                      <option value="Jee Mains-2 Results">JEE Mains-2 Results</option>
                      <option value="Eamcet Results">EAMCET Results</option>
                      <option value="IPE Results">IPE Results</option>
                      <option value="Supply Exams">Supply Exams</option>
                      <option value="Supply Results">Supply Results</option>
                      <option value="EOD">EOD</option>
                    </select>
                  </div>
                )}

                {/* OTHER REASON */}
                {formData.is_interested === "Others" && (
                  <div className="mt-5 rounded-lg border border-slate-200 bg-gray-50 p-4">
                    <label htmlFor="other_reasons" className={labelClass} style={labelStyle}>
                      Other Reason <span className="text-red-500">*</span>
                    </label>
                    <select
                      id="other_reasons"
                      name="other_reasons"
                      value={formData.other_reasons || ""}
                      onChange={handleChange}
                      className={inputClass}
                      required
                    >
                      <option value="">Select Reason</option>
                      <option value="Wrong Number">Wrong Number</option>
                      <option value="Not Reachable">Not Reachable</option>
                      <option value="Number Not Working">Number Not Working</option>
                      <option value="Call Declined">Call Declined</option>
                      <option value="Busy">Busy</option>
                      <option value="Switched Off">Switched Off</option>
                      <option value="Incoming Calls Stopped">Incoming Calls Stopped</option>
                    </select>
                  </div>
                )}
              </section>
            </div>

            {/* ================= STICKY FOOTER ================= */}
            <div className="sticky bottom-0 z-10 flex flex-col-reverse gap-3 border-t border-slate-100 bg-white px-5 py-4 sm:flex-row sm:items-center sm:justify-between sm:px-6">
              <p className="text-xs text-gray-500">
                <span className="text-red-500">*</span> Required fields
              </p>

              <div className="flex flex-col-reverse gap-3 sm:flex-row">
                <button
                  type="button"
                  onClick={handleCloseModal}
                  className="rounded-lg border border-gray-300 bg-white px-5 py-2.5 text-sm font-semibold text-gray-600 transition hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-[#172C57]"
                >
                  Cancel
                </button>

                <button
                  type="submit"
                  style={{
                    backgroundColor: loadingSubmit
                      ? THEME.disabledGray
                      : THEME.primary,
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.opacity = "0.9")}
                  onMouseLeave={(e) => (e.currentTarget.style.opacity = "1")}
                  className="inline-flex items-center justify-center gap-2 rounded-lg px-7 py-2.5 text-sm font-semibold text-white shadow-sm transition-opacity disabled:opacity-60 disabled:cursor-not-allowed focus:outline-none focus:ring-2 focus:ring-[#172C57] focus:ring-offset-2"
                >
                  Save Student Details
                </button>
              </div>
            </div>
          </form>
        </Modal>
      </div>
    </div>
  );
};

export default AssignedStudents;